// Phase C · formatter condiviso quantità (UI-only, NON altera il dato backend).
// Max 2 decimali, zeri finali non significativi rimossi, separatore decimale IT.
export const fmtQty = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  return n.toLocaleString('it-IT', { maximumFractionDigits: 2 });
};

// Percentuale con max 2 decimali + simbolo.
export const fmtPct = (v) => {
  const n = Number(v) || 0;
  return `${n.toLocaleString('it-IT', { maximumFractionDigits: 2 })}%`;
};

// Euro con 2 decimali.
export const fmtEur = (v) => {
  const n = Number(v) || 0;
  return `€ ${n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Parse input IT/EN → number (virgola o punto).
export const parseNum = (s) => parseFloat(String(s).replace(',', '.'));
